import LoanInfo from "./loan-info";

export default LoanInfo